import { useMutation } from "@tanstack/react-query";
import { submitWallet, getWallet } from "../api";

export function useSubmitWallet() {
    return useMutation({ mutationFn: submitWallet });
}

export function useGetWallet() {
    return useMutation({ mutationFn: getWallet });
}